<template>
  <div class="pa-4 mt-5">    
   <v-chip :color="getChipColor(x)" pill x-small v-for="(x,i) in Object.keys(msg.ops)" :key="i">  {{x}} </v-chip>          
     
   <h2>{{msg.message}} </h2>
   <p class="mt-4"> {{msg.created.toDate() | formatDate}}
     </p>
     <div class="text-center mt-4">
        <v-btn @click="$router.push('/')" class="success ma-2" >  Back </v-btn>
        <v-btn v-if="claims.isAdmin" @click="removeItem(msg)" class="error ma-2" > Remove  </v-btn>
     </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        pgname: "Message",
       
      }
    },
    computed:{
       msg(){
         return this.$store.getters.Message
       },
       claims(){
         return this.$store.getters.Claims
       }
    },
    methods:{
      getChipColor(item){
          
        let cols = this.$store.getters.AlertTypes  
        let itm = cols.find(n=> n.name==item);
      return itm.color;

    },
      removeItem: function(msg){

        this.$store.dispatch("removeAlert", msg.id);
        this.$router.push('/');
      }
    },
    mounted(){
     // console.log("params", this.params);
    }
  }
</script>